<template>
  <div class="TuPuClass">
    <iframe :src="iframeUrl" width="100%" height="100%" id="iframeId"/>
  </div>
</template>

<script>
import Top from "./comp/LeftTopTuPu.vue"
import Bottom from "./comp/LeftBottomTuPu.vue"
import userApi from "@/api/user";
export default {
  components: {
    Top,Bottom
  },
  data() {
    return {
      iframeUrl: "https://edam.tscon.cn:7778/wenda53/mcc/zhenchong_ml/#/zstp",
      // iframeUrl: "http://localhost:5173/#/zstp",
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style scoped>

.TuPuClass {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

>>> #iframeId {
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
}


</style>



// WEBPACK FOOTER //
// src/views/Tupu/tupu.vue